import { Box, Divider, Text, VStack } from '@chakra-ui/react'
import { PatientConsentFormStatus } from '@hb/shared'
import { ConsentFormStatusView } from './ConsentForms/ConsentFormStatusView'

export const ConfirmResendConsentForm = ({
  existingTemplateConsentFormStatus,
  patientId,
}: {
  existingTemplateConsentFormStatus: PatientConsentFormStatus
  patientId: string
}) => (
  <VStack w="100%" flexFlow="column" spacing={0} divider={<Divider />}>
    <Box px={4} pb={2}>
      <Text fontSize="lg" fontWeight={500} color="gray.600">
        Re-Send Consent Form?
      </Text>
      <Text>
        This consent form has already been sent to the patient. Do you want to re-send it?
      </Text>
    </Box>
    <ConsentFormStatusView formStatus={existingTemplateConsentFormStatus} patientId={patientId} />
  </VStack>
)
